import React, { useEffect, useRef } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App.jsx';
import { UserContextProvider } from "./UserContext.jsx";
import { Error } from './pages/Error.jsx';
import { useMsal } from "@azure/msal-react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionStatus } from '@azure/msal-browser';

const AppWrapper = () => {
	const { instance, accounts, inProgress } = useMsal();
	const location = useLocation();
	const loginInitiated = useRef(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	useEffect(() => {
		const handleAuth = async () => {
			try {
				if (
					accounts.length === 0 &&
					inProgress === InteractionStatus.None &&
					!loginInitiated.current
				) {
					loginInitiated.current = true;
					await instance.loginRedirect({
						scopes: ['user.read'],
					});
				}
			} catch (error) {
				console.error('Authentication error:', error);
				loginInitiated.current = false;
			}
		};

		handleAuth();
	}, [accounts, instance, inProgress]);

	return (
		<Routes>
			<Route path="/error" element={<Error />} />
			<Route
				path="*"
				element={
					<>
						<UnauthenticatedTemplate>No Users Logged In</UnauthenticatedTemplate>
						<AuthenticatedTemplate>
							<UserContextProvider>
								<App />
							</UserContextProvider>
						</AuthenticatedTemplate>
					</>
				}
			/>
		</Routes>
	);
}

export default AppWrapper;
